import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon  } from 'mdbreact';
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert  } from 'antd';
import Modalarticlefaculty from './Modalarticlefaculty';
import Modalsentedit from './Modalsentedit';
import Modalsuccess from './Modalsuccess';
import Modalarticlefacultybn from './Modalarticlefacultybn';
import Commentbnlistforadminfaculty from './Commentbnlistforadminfaculty';
import Modalarticlefacultyex from './Modalarticlefacultyex';
import Commentexlistforadminfaculty from './Commentexlistforadminfaculty';
import Commentexlistforadminfacultytrue from './Commentexlistforadminfacultytrue';










export default class adminfaculty extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci01:[],
          articlesci1:[],
          articlestapat2:[],
          articlestapat3:[],
          articlestapat4:[],
          articlestapat5:[],
          articlestapat6:[],
            article2:[],

            activeItem: "1",
            admin_faculty:"",
        };
         this.selectarticlefaculty = this.selectarticlefaculty.bind(this);
          this.selectatf = this.selectatf.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
        // this.updateat = this.updateat.bind(this);
      }



      componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
            this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        }

        setTimeout(() => {
           //ภายใน

            //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty01.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci01: res.data})
           }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

          // Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat2.php?faculty='+localStorage.getItem('admin_faculty'))
           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat2.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat2: res.data})
           }) 

          // Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat3.php?faculty='+localStorage.getItem('admin_faculty'))
           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat3.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat3: res.data})
           }) 

          // Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat4.php?faculty='+localStorage.getItem('admin_faculty'))
           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat4.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat4: res.data})
           }) 

          // Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat5.php?faculty='+localStorage.getItem('admin_faculty'))
           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat5.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat5: res.data})
           }) 

          // Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat6.php?faculty='+localStorage.getItem('admin_faculty'))
           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat6.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat6: res.data})
           }) 

         }, 0);
      }

      selectatf() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
            this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        }

        setTimeout(() => {

            //ภายใน
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty01.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

           //ภายใน
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat2.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat2: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat3.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat3: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat4.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat4: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat5.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat5: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat6.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat6: res.data})
           }) 

         }, 0);
      }


      selectarticlefaculty() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
            this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        }
        setTimeout(() => {
           //ภายใน
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

         }, 0);
      }


    render() {
        return (
            <MDBContainer fluid>
            <div>
               

                <p className="text-right"> (ผู้ดูแลระบบระดับคณะ)</p>
                <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 

                { localStorage.getItem('admin_faculty') == 7 ? <><p className="text-right">มรภ.กพ แม่สอด</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 6 ? <><p className="text-right">คณะพยาบาลศาสตร์</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 5 ? <><p className="text-right">คณะเทคโนโลยีอุตสาหกรรม</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 4 ? <><p className="text-right">คณะวิทยาการจัดการ</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 3 ? <><p className="text-right">คณะมนุษยศาสตร์และสังคมศาสตร์</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 2 ? <><p className="text-right">คณะวิทยาศาสตร์และเทคโนโลยี</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 1 ? <><p className="text-right">คณะครุศาสตร์</p></>:<></>}

               <p className="text-right"><a href="https://conference.kpru.ac.th/adminconference-sd/download/adminfaculty.pdf" target="_blank" > <MDBBtn color="primary"  size="sm">คู่มือการใช้งาน</MDBBtn></a></p> 


               <MDBAlert color="success" >
                   <h4><MDBIcon icon="address-book" className="green-text pr-3" /> บทความเข้าใหม่ (ขั้นตอนนี้ต้องปิดชื่อผู้เขียน)</h4>
                
                </MDBAlert>

                {/* <Alert message={"บทความภายใน สาขาวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlesci1.length+" บทความ"} type="info" /> */}
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                    {this.state.articlesci01.map((articlesci01,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlesci01.send_name}  </td>
                        <td>{articlesci01.register_pname}{articlesci01.register_nameth}  {articlesci01.register_lnameth}<br/>{articlesci01.register_phone} </td>
                        <td>{articlesci01.major_precent}</td>
                        <td>
                          {/* <MDBBtn color="indigo" size="sm" href={articlesci01.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlesci01.send_uploadepdf1}  target="_blank">PDF</MDBBtn> */}
                          <MDBBtn color="indigo" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/upload/${articlesci01.send_uploadeword1}`}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/upload/${articlesci01.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                          </td>
                    <td>   <Modalarticlefacultybn  id_send={articlesci01.id_send} namearticla={articlesci01.send_name} selectatf={this.selectatf}/></td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>

                <MDBAlert color="success" >
                   <h4><MDBIcon icon="address-book" className="green-text pr-3" /> บทความรอบรรณาธิการพิจารณา(ส่งให้บรรณาธิการ)</h4>
                </MDBAlert>
                {/* <Alert message={"บทความภายใน สาขาวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlesci1.length+" บทความ"} type="info" /> */}
             <MDBTable responsive bordered>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ(ปิดชื่อแล้ว)</th>
                        <th className='text-center'>สถานะการปรับแก้</th>
                        <th>จัดการผู้ทรงคุณวุฒิ</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                    {this.state.articlesci1.map((articlesci1,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlesci1.send_name}  </td>
                        <td>{articlesci1.register_pname}{articlesci1.register_nameth}  {articlesci1.register_lnameth}<br/>{articlesci1.register_phone} </td>
                        <td>{articlesci1.major_precent}</td>

                        <td>
                        <MDBBtn color="indigo" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/closeacticle/${articlesci1.sendclose_uploadeword1}`}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/closeacticle/${articlesci1.sendclose_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                          {/* <MDBBtn color="indigo" size="sm" href={articlesci1.sendclose_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlesci1.sendclose_uploadepdf1}  target="_blank">PDF</MDBBtn> */}
                          </td>
                        <td><Commentbnlistforadminfaculty id_send={articlesci1.id_send} bn_comment={articlesci1.bn_comment} /> </td>
                        <td>   <Modalarticlefacultyex  id_send={articlesci1.id_send} namearticla={articlesci1.send_name} selectatf={this.selectatf}/></td>
                        </tr>
                      )}
                    </MDBTableBody>


             </MDBTable>

               <MDBAlert color="primary" >
                   <h4><MDBIcon icon="shipping-fast"  className="blue-text pr-3"/> บทความรอผู้ทรงคุณวุฒิพิจารณา(ส่งให้ผู้ทรงคุณวุฒิ)</h4>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>วันที่ส่ง</th>
                        <th>ไฟล์บทความ</th>
                        {/* <th>จัดการ</th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlestapat2.map((articlestapat2,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlestapat2.send_name}  </td>
                        <td>{articlestapat2.register_pname}{articlestapat2.register_nameth}  {articlestapat2.register_lnameth} <br/>{articlestapat2.register_phone} </td>
                        <td>{articlestapat2.major_precent}</td>
                        <td>{articlestapat2.date_stap2}</td>
                        <td>
                    <Commentexlistforadminfaculty id_send={articlestapat2.id_send} bn_comment={articlestapat2.ex_comment} />
                          {/* <MDBBtn color="indigo" size="sm" href={articlestapat2.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlestapat2.send_uploadepdf1}  target="_blank">PDF</MDBBtn> */}
                          </td>
                    {/* <td>   <Modalarticlefaculty  id_send={articlesci1.id_send} namearticla={articlesci1.send_name} /></td> */}
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>

           <MDBAlert color="primary" >
                   <h4><MDBIcon icon="shipping-fast"  className="blue-text pr-3"/> บทความผ่านพิจารณาแล้ว</h4>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>วันที่ส่ง</th>
                        <th>ไฟล์บทความ</th>
                        {/* <th>จัดการ</th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlestapat3.map((articlestapat3,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlestapat3.send_name}  </td>
                        <td>{articlestapat3.register_pname}{articlestapat3.register_nameth}  {articlestapat3.register_lnameth} <br/>{articlestapat3.register_phone} </td>
                        <td>{articlestapat3.major_precent}</td>
                        <td>{articlestapat3.date_stap2}</td>
                        <td>
                    <Commentexlistforadminfacultytrue id_send={articlestapat3.id_send} bn_comment={articlestapat3.ex_comment} />
                          {/* <MDBBtn color="indigo" size="sm" href={articlestapat2.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlestapat2.send_uploadepdf1}  target="_blank">PDF</MDBBtn> */}
                          </td>
                    {/* <td>   <Modalarticlefaculty  id_send={articlesci1.id_send} namearticla={articlesci1.send_name} /></td> */}
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>

               {/* <MDBAlert color="danger" >
                   <h4> <MDBIcon icon="book-reader" className="pink-text pr-3"/> บทความผู้ทรงคุณวุฒิพิจารณาแล้ว (ขั้นตอนนี้ต้องปิดชื่อผู้ทรงคุณวุฒิ)</h4>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>วันที่ส่งกลับ</th>
                        <th>ไฟล์ข้อเสนอแนะ</th>
                        <th>จัดการส่งคืน</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlestapat3.map((articlestapat3,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlestapat3.send_name}  </td>
                        <td>{articlestapat3.register_pname}{articlestapat3.register_nameth}  {articlestapat3.register_lnameth} <br/>{articlestapat3.register_phone}  </td>
                        <td>{articlestapat3.major_precent}</td>
                        <td>{articlestapat3.date_stap3}</td>
                        <td> <MDBBtn color="pink" size="sm" href={articlestapat3.send_commentexpert}  target="_blank">ข้อเสนอแนะ</MDBBtn>
                             { articlestapat3.filerate !== null ? <><MDBBtn color="light-blue" size="sm" href={articlestapat3.filerate}  target="_blank">แบบประเมิน</MDBBtn></> :<></>}</td>

                        <td> <Modalsentedit id_send={articlestapat3.id_send} namearticla={articlestapat3.send_name}  selectatf={this.selectatf}/></td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable> */}

                {/* <MDBAlert color="warning" >
                   <h4><MDBIcon icon="user-edit" className="orange-text pr-3" /> บทความอยู่ระหว่างผู้เขียนปรับแก้ไข</h4>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>วันที่ส่งให้ปรับแก้ไข</th>
                        <th>ไฟล์ข้อเสนอแนะ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlestapat4.map((articlestapat4,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlestapat4.send_name}  </td>
                        <td>{articlestapat4.register_pname}{articlestapat4.register_nameth}  {articlestapat4.register_lnameth}  <br/>{articlestapat4.register_phone} </td>
                        <td>{articlestapat4.major_precent}</td>
                        <td>{articlestapat4.date_stap4}</td>
                        <td> <MDBBtn color="pink" size="sm" href={articlestapat4.send_filecommect1}  target="_blank">PDF</MDBBtn></td>
                   
                        </tr>
                      )}
                    </MDBTableBody>
               </MDBTable> */}


           {/* <MDBAlert color="info" >
                   <h4><MDBIcon icon="envelope" className="cyan-text pr-3"/> บทความผู้เขียนปรับแก้ไขกลับมา </h4>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>วันที่แก้ไขกลับ</th>
                        <th>ไฟล์ข้อเสนอแนะ<br/>(เพื่อประกอบการตรวจสอบ)</th>
                        <th>ไฟล์ปรับแก้ไข</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlestapat5.map((articlestapat5,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlestapat5.send_name}  </td>
                        <td>{articlestapat5.register_pname}{articlestapat5.register_nameth}  {articlestapat5.register_lnameth} <br/>{articlestapat5.register_phone}</td>
                        <td>{articlestapat5.major_precent}</td>
                        <td>{articlestapat5.send_date2}</td>
                        <td><MDBBtn color="pink" size="sm" href={articlestapat5.send_filecommect1}  target="_blank">ข้อเสนอแนะผู้ทรง</MDBBtn><MDBBtn color="light-blue" size="sm" href={articlestapat5.bn_filecommect1}  target="_blank">ข้อเสนอแนะบรรณาธิการ</MDBBtn></td>
                        <td><MDBBtn color="indigo" size="sm" href={articlestapat5.send_uploadeword2}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlestapat5.send_uploadepdf2}  target="_blank">PDF</MDBBtn></td>
                        <td><Modalsuccess  id_send={articlestapat5.id_send} namearticla={articlestapat5.send_name} selectatf={this.selectatf} /></td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable> */}
            </div>
            </MDBContainer>

        )
    }
}
